var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useState, useCallback } from "react";
import { TLoaderButtonState } from "./LoaderButtonTypes";
import { default as BaseLoaderButton } from "./LoaderButton";
var useLoaderButton = function (hookProps) {
    if (hookProps === void 0) { hookProps = {}; }
    var _a = useState(hookProps.state || TLoaderButtonState.Normal), hookedState = _a[0], setHookedState = _a[1];
    var enableButton = useCallback(function () {
        setHookedState(TLoaderButtonState.Normal);
    }, []);
    var disableButton = useCallback(function () {
        setHookedState(TLoaderButtonState.Disabled);
    }, []);
    var setLoadingButton = useCallback(function () {
        setHookedState(TLoaderButtonState.Loading);
    }, []);
    var modProps = __assign(__assign({}, hookProps), { state: hookedState });
    var LoaderButton = function (props) {
        var localProps = __assign(__assign({}, modProps), props);
        return (React.createElement(BaseLoaderButton, __assign({}, localProps), localProps.children));
    };
    return {
        LoaderButton: LoaderButton,
        enableButton: enableButton,
        disableButton: disableButton,
        setLoadingButton: setLoadingButton,
    };
};
export default useLoaderButton;
//# sourceMappingURL=useLoaderButton.js.map